export default {
    methods: {
        requireAsset(path) {
            return require(path);
        }
    }
}